'use client'

import { ThemeProvider as MUIThemeProvider, createTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { ReactNode, useMemo } from 'react'
import { ThemeKey } from './resolveTheme'
import { getThemeOptions } from './themes'

export default function ThemeProvider({
    children,
    direction,
    themeKey
}: {
    children: ReactNode
    direction: 'rtl' | 'ltr'
    themeKey: ThemeKey
}) {
    // themeKey comes from the server (resolved from the host), so SSR and the client agree.
    const theme = useMemo(() => createTheme(getThemeOptions(themeKey), { direction }), [themeKey, direction])
    return (
        <MUIThemeProvider theme={theme}>
            <CssBaseline />
            {children}
        </MUIThemeProvider>
    )
}
